import { SubjectData } from 'shell/models/person';
import { AccordionCivilStatus as CivilStatusVM } from 'shell/view-models/accordion-civil-status';

export const transformCivilStatus = (person: SubjectData): CivilStatusVM | undefined => {
  const originReturnData: CivilStatusVM | undefined = person.statoCivile
    ? {
        status: person?.statoCivile?.statoCivile || '',
        available: person?.statoCivile?.statoCivileND === '1' ? true : false,
        note: person?.statoCivile?.noteStatoCivile || '',
      }
    : undefined;

  return originReturnData;
};
